import type { Icon } from "@tabler/icons-react";
import {
  IconBook,
  IconBrain,
  IconChartBar,
  IconCreditCard,
  IconDashboard,
  IconKey,
  IconUser,
} from "@tabler/icons-react";

export type SidebarNavItem = {
  title: string;
  url: string;
  icon: Icon;
};

/** Main — Dashboard + Models */
export const appSidebarNavMain: SidebarNavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: IconDashboard,
  },
  {
    title: "Models",
    url: "/deploy/models",
    icon: IconBrain,
  },
];

/** Developer — API keys + Docs + Usage (keep in sync with services/frontend/shared/navigation/app-sidebar-nav.ts) */
export const appSidebarNavDeveloper: SidebarNavItem[] = [
  {
    title: "API keys",
    url: "/deploy/keys",
    icon: IconKey,
  },
  {
    title: "Docs",
    url: "/docs/",
    icon: IconBook,
  },
  {
    title: "Usage",
    url: "/analytics",
    icon: IconChartBar,
  },
];

/** Account — Account + Billing */
export const appSidebarNavAccount: SidebarNavItem[] = [
  {
    title: "Account",
    url: "/manage/account",
    icon: IconUser,
  },
  {
    title: "Billing",
    url: "/manage/billing",
    icon: IconCreditCard,
  },
];

/** Flat list for user menu dropdown (same order as sidebar). */
export const appSidebarNavAll: SidebarNavItem[] = [
  ...appSidebarNavMain,
  ...appSidebarNavDeveloper,
  ...appSidebarNavAccount,
];
